import * as yup from 'yup'
import { emailSchema, passwordSchema, simplePasswordSChema, uniqueIdSchema } from './userSchema'

export const patientLoginSchema = yup.object({
  password: simplePasswordSChema,
  email: emailSchema
})

export const staffLoginSchema = yup.object({
  password: simplePasswordSChema,
  unique_id: uniqueIdSchema,
  unit_id: yup.string().required('Ward/Unit is required')
})

export const adminLoginSchema = yup.object({
  password: simplePasswordSChema,
  unique_id: uniqueIdSchema,
  unit_id: yup.string().optional()
})

export const acceptInviteSchema = yup.object({
  password: passwordSchema,
  password_confirmation: passwordSchema
})
export const forgotPasswordSchema = yup.object({ email: emailSchema }).required()
